module.exports = __webpack_public_path__ + "img/edit-alt-2.987814c5.svg";